var map = {
	"./Speaker=Aarthi Scott.png": "49d3",
	"./Speaker=Aashni Shah.png": "3d73",
	"./Speaker=Akshaya Dinesh.png": "0b79",
	"./Speaker=Alex Ng.png": "ff0c",
	"./Speaker=Alice Gao.png": "0852",
	"./Speaker=Alison Adnani.png": "d0a7",
	"./Speaker=Amanda DoAmaral.png": "6900",
	"./Speaker=Amjad Masad.png": "bd7c",
	"./Speaker=Amma Kwateng.png": "5458",
	"./Speaker=Arielle Lok.png": "4eed",
	"./Speaker=Aubrey de Grey.png": "920d",
	"./Speaker=Benjamin Sehl.png": "d6c7",
	"./Speaker=Bernard Moon.png": "df9e",
	"./Speaker=Bryan Pham.png": "bcb2",
	"./Speaker=CUTC Team.png": "7506",
	"./Speaker=Caris Frazier-Baker.png": "32c2",
	"./Speaker=Carl Barrelet.png": "7680",
	"./Speaker=Carrie Lim.png": "46f9",
	"./Speaker=Chander Subramaniam.png": "f8b1",
	"./Speaker=Cindy Fang.png": "c254",
	"./Speaker=Clarisse Schneider.png": "a4b1",
	"./Speaker=Crystal Hunt.png": "b5d1",
	"./Speaker=Daniel Huang.png": "0c3f",
	"./Speaker=Daryl Senick.png": "640b",
	"./Speaker=David Thompson.png": "701f",
	"./Speaker=Default.png": "d0dd",
	"./Speaker=Denis Repin.png": "2d03",
	"./Speaker=Don Munasinghe.png": "d495",
	"./Speaker=Eddie Wang.png": "fcfa",
	"./Speaker=Eptehal Nashnoush.png": "a3f6",
	"./Speaker=Faisal Abid.png": "2958",
	"./Speaker=Farzan Nadeem.png": "aa32",
	"./Speaker=Franziska Boenisch.png": "59b9",
	"./Speaker=Ge Wang.png": "f823",
	"./Speaker=Harley Finkelstein.png": "8ceb",
	"./Speaker=Helen Huang.png": "f35a",
	"./Speaker=Indra Sofian.png": "3238",
	"./Speaker=Iris Guo.png": "df7e",
	"./Speaker=Jamie Quint.png": "6514",
	"./Speaker=Jay Krishnan.png": "d3cc",
	"./Speaker=Jazz Rossi.png": "19be",
	"./Speaker=Jean-Michel Lemieux.png": "085e",
	"./Speaker=Jeff Nguyen.png": "ee16",
	"./Speaker=Jenn Henley.png": "60cb",
	"./Speaker=Jenny Sun.png": "ab76",
	"./Speaker=Jerry Lee.png": "4f98",
	"./Speaker=Jihoon Jeong.png": "1972",
	"./Speaker=John Weigelt.png": "d3aa",
	"./Speaker=Jonathan Javier.png": "11c6",
	"./Speaker=Jonathan Pavan.png": "5a6c",
	"./Speaker=Jonny Hsu.png": "4484",
	"./Speaker=Josh Sirefman.png": "c25e",
	"./Speaker=Justin Zheng.png": "fee8",
	"./Speaker=Kaitlyn Barnett.png": "95ff",
	"./Speaker=Kaivalya Gandhi.png": "f8b9",
	"./Speaker=Karly Hou.png": "3063",
	"./Speaker=Kevin Lau.png": "349f",
	"./Speaker=Kevin Xu.png": "46b1",
	"./Speaker=Laila Albalkhi.png": "17f4",
	"./Speaker=Lakey Hu.png": "613d",
	"./Speaker=Leo Zhou.png": "42ed",
	"./Speaker=Leonard Lee.png": "e061",
	"./Speaker=Linda Chen.png": "fcaf",
	"./Speaker=Malte Lauterbach.png": "93b2",
	"./Speaker=Mark Patterson.png": "391f",
	"./Speaker=Matt Espinoza.png": "2b77",
	"./Speaker=Matt Zhao.png": "2ae3",
	"./Speaker=Michael Ioffe.png": "aa9e",
	"./Speaker=Michelle Ouellet.png": "8064",
	"./Speaker=Michelle Qin.png": "73a2",
	"./Speaker=Michelle Reyes.png": "9cf0",
	"./Speaker=Minjun Chen.png": "b939",
	"./Speaker=Motasem Salem.png": "340c",
	"./Speaker=Muna Khayyat.png": "2ff4",
	"./Speaker=Neil Sharma.png": "f3b8",
	"./Speaker=Om Gandhi.png": "1b2c",
	"./Speaker=Omna Toshniwal.png": "7fde",
	"./Speaker=Parth Sareen.png": "344c",
	"./Speaker=Peter Poydenko.png": "09a7",
	"./Speaker=Phoenix Normand.png": "614a",
	"./Speaker=Piro Dhimitri.png": "c454",
	"./Speaker=Priya Ghose.png": "dcbc",
	"./Speaker=Rahul Rana.png": "91f5",
	"./Speaker=Ralf Klinkenberg.png": "1712",
	"./Speaker=Ramona Pringle.png": "8aa2",
	"./Speaker=Ravi Ravindran.png": "8cd6",
	"./Speaker=Rebecca Wellum.png": "4cff",
	"./Speaker=Rishan Lye.png": "2575",
	"./Speaker=Robin Orsini.png": "c550",
	"./Speaker=Robyn Orsini.png": "4753",
	"./Speaker=Russell Sng.png": "1d0b",
	"./Speaker=Ryan D'Silva.png": "b5ba",
	"./Speaker=Sabrina Chartrand.png": "5dea",
	"./Speaker=Sara Du.png": "509e",
	"./Speaker=Sarah Gray.png": "a407",
	"./Speaker=Serena Li.png": "c444",
	"./Speaker=Serena McDonnell.png": "0293",
	"./Speaker=Shabrana Aman.png": "3a8e",
	"./Speaker=Shafina Hassam.png": "d525",
	"./Speaker=Shirley Moore.png": "71568",
	"./Speaker=Sofia Dala.png": "965a",
	"./Speaker=Sonia Edmonds.png": "eb24",
	"./Speaker=Sophia Dhrolia.png": "fb6ad",
	"./Speaker=Susan Ibach.png": "d172",
	"./Speaker=Susan Shu Chang.png": "0390",
	"./Speaker=Syed Shahzad Raza.png": "25de",
	"./Speaker=Talia Kennedy.png": "ddcc",
	"./Speaker=Tianyu Guo.png": "b94a",
	"./Speaker=Victor Kovalev.png": "2548",
	"./Speaker=Vivek Gupta.png": "2ed6",
	"./Speaker=Vivian Li.png": "9b87",
	"./Speaker=Vivian Phung.png": "9d1d",
	"./Speaker=Wen L. Zhou.png": "91a3",
	"./Speaker=Wendy Cukier.png": "873b",
	"./Speaker=Winona Huang.png": "6106",
	"./Speaker=Yash Godiwala.png": "8022",
	"./Speaker=Zach Latta.png": "379a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e495";